// extracted by mini-css-extract-plugin
export default {"datenschutzContainer":"Datenschutz_datenschutzContainer__L5VDi","infoBox":"Datenschutz_infoBox__uF6hH"};